import $ from "jquery";
import Flickity from "flickity-fade";
import "flickity-imagesloaded";

class ReviewsSlider {
	constructor($el) {
		this.$el = $el;
		this.$wrapper = this.$el.parent();
        this.$buttons = this.$wrapper.find('.slider__button');

		this.options = {
			// autoPlay: true,
			pageDots: false,
			wrapAround: true,
			prevNextButtons: false,
			freeScroll: true,
			cellSelector: ".reviews-slider__slide",
			cellAlign: 'left',
		};

		if (this.$el.length) {
			this._init();
			this._bindEvents();
		}
	}

    _init() {
        this.$slides = this.$el.find('.reviews-slider__slide');
        this.slidesCount = this.$slides.length;

        if(this.slidesCount > 0) {
            this._createSlider();
        }
    }

	_bindEvents() {
        this.$buttons.on('click', this._onButtonClick.bind(this));
    }

    _onButtonClick(e) {
        const $target = $(e.currentTarget);

        if($target.hasClass('slider__button--previous')) {
            this.slider.previous(true);
            // console.log('précédent');
        }
        else if($target.hasClass('slider__button--next')) {
            this.slider.next(true);
            // console.log('suivant');
        }
    }

	_createSlider() {
        this.slider = new Flickity(this.$el[0], this.options);
    }
}

export default ReviewsSlider;
